import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataConnectService } from 'src/app/services/data-connect.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-detalle-oirs',
  templateUrl: './detalle-oirs.component.html',
  styleUrls: ['./detalle-oirs.component.css']
})
export class DetalleOirsComponent implements OnInit {

  env = environment;
  id: number;
  datos: any;
  respuesta: string = 'a';
  imagenessubidas: any
  archivo: string;
  imgbase64: any;
  muchopeso: boolean;
  tipoformatoimagen: any;
  formValidators = {
    'respuesta': [
      { type: 'required', message: 'Ingrese su Mensaje' },
      { type: 'minLength', message: 'Debe Tener un Largo Mayor a 1 caracter' },
      { type: 'maxLength', message: 'Debe ser Menos a 12000 Caracteres' },
    ],
    'archivo': [
      { type: 're', message: 'El Archivo no Puede pesar Más de 2 Mb' }

    ],
    'size': [
      { type: 'Incorrect', message: 'El Archivo No Puede Pesar Más de 1 Mb' }
    ],
  }

  oirsrespuesta: FormGroup;
  image: any;
  size: any;
  unit: any;
  datosDetalle: any;
  base64: any;
  test: any;
  imageName: string;
  imageBlob: any;

  conectado: any = {
    correcto: 'true',
    message: ""
  }


  get f(): any { return this.oirsrespuesta.controls; }
  constructor(private router: Router, private route: ActivatedRoute, private _service: DataConnectService, private confirmdialogservice: ConfirmDialogService,
    private auth: AuthService, public sanitizer: DomSanitizer) {
    if (this._service.lista == undefined) {
      this.router.navigate(['/inicio']);
    }
  }

  ngOnInit() {

    this._service.verificaTokenOficial().subscribe((res: any) => { this.conectado = res })


    if (this.conectado.correcto) {

      this.route.params.subscribe(params => {

        this.id = +params['IDSolicitud']; // (+) converts string 'id' to a number

      });

      this.datos = this._service.lista.filter(d => d.IDSolicitud == this.id);
      //console.log(this.datos)
      this.detalle(this.id, this.datos[0].CDReparticion)
      this.imagenes(this.id)
      this.oirsrespuesta = new FormGroup({
        respuesta: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(12000)]),
        pregunta: new FormControl(this.datos[0].GLSolicitud),//carnet o pasaporte
        asignacion: new FormControl(this.datos[0].GLObservacion),//carnet o pasaporte
        glasignacionusuarioadmin: new FormControl(this.datos[0].glasignacionusuarioadmin),//carnet o pasaporte
        archivo: new FormControl(''),
        base64: new FormControl(''),
        size: new FormControl('', [Validators.max(2000000)]),
        TPFormato: new FormControl(''),
        CDReparticion: new FormControl(this.datos[0].CDReparticion)
      });
    }
    else {
      console.log("desconectar")
      this.auth.logout();
    }
  }
  eliminar() {
    this.oirsrespuesta.controls['base64'].setValue(null)
    this.oirsrespuesta.controls['size'].setValue(null)
    this.oirsrespuesta.controls['archivo'].setValue(null)
    this.image = null;
    this.size = null;
    this.unit = null;

  }
  detalle(id, repar) {
    return this._service.ver(id, repar).subscribe(
      res => {
        //console.log(res)
        this.datosDetalle = res
      }
    )

  }
  dataURItoBlob(dataURI, formato) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    var formatoaux;
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    if (formato == 'PDF') {
      formatoaux = 'application/PDF'
    } else if (formato == 'JPG' || formato == 'PNG') {
      formatoaux = `image/${formato}`
    } else if (formato == 'DOC') {
      formatoaux = 'application/msword'
    } else if (formato == 'XLS') {
      formatoaux = 'application/vnd.ms-excel'
    }
    const blob = new Blob([int8Array], { type: formatoaux });
    return blob;
  }
  verimg(IDSolicitud, NMTPFormato) {

    this.imagenessubidas.forEach(element => {

      if (element.IDSolicitud == IDSolicitud) {

        if (element.NMTPFormato == 'PDF') {
          this.base64 = element.imgbase64.split(',')
          ////console.log(this.base64[1])
          this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${element.imgbase64}`) }
          this.imageName = `Adjunto.${element.NMTPFormato}`;
          this.imageBlob = this.dataURItoBlob(this.base64[1], element.NMTPFormato);
          this.test = new File([this.imageBlob], this.imageName, { type: `application/${element.NMTPFormato}` });
          const url = window.URL.createObjectURL(this.test);
          window.open(url);

          //console.log(this.test)
        } else if (element.NMTPFormato == 'JPG' || element.NMTPFormato == 'PNG') {
          this.base64 = element.imgbase64.split(',')
          //console.log(this.base64[1])
          this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${element.imgbase64}`) }
          this.imageName = `Adjunto.${element.NMTPFormato}`;
          this.imageBlob = this.dataURItoBlob(this.base64[1], element.NMTPFormato);
          this.test = new File([this.imageBlob], `Adjunto.${element.NMTPFormato}`, { type: `image/${element.NMTPFormato}` });
          const url = window.URL.createObjectURL(this.test);
          window.open(url);
        } else if (element.NMTPFormato == 'DOC') {
          this.base64 = element.imgbase64.split(',')
          //console.log(this.base64[1])
          this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${element.imgbase64}`) }
          this.imageName = `Adjunto.${element.NMTPFormato}`;
          this.imageBlob = this.dataURItoBlob(this.base64[1], element.NMTPFormato);
          this.test = new File([this.imageBlob], `Adjunto.${element.NMTPFormato}`, { type: `application/msword` });
          const url = window.URL.createObjectURL(this.test);
          window.open(url);
        } else if (element.NMTPFormato == 'XLS') {
          this.base64 = element.imgbase64.split(',')
          //console.log(this.base64[1])
          this.test = { obj: this.sanitizer.bypassSecurityTrustUrl(`${element.imgbase64}`) }
          this.imageName = `Adjunto.${element.NMTPFormato}`;
          this.imageBlob = this.dataURItoBlob(this.base64[1], element.NMTPFormato);
          this.test = new File([this.imageBlob], `Adjunto.${element.NMTPFormato}`, { type: `application/vnd.ms-excel` });
          const url = window.URL.createObjectURL(this.test);
          window.open(url);
        }

      }
    })
  }

  imagenes(idSolicitud) {
    //console.log(idSolicitud)
    return this._service.Imagenes(idSolicitud).subscribe(
      res => {
        this.imagenessubidas = res
      });
  }
  changeListener($event) {
    const file = $event.target.files[0];
    this.tipoformatoimagen = $event.target.files[0].type.split('/')
    //console.log(this.tipoformatoimagen[1]);
    if (parseInt($event.target.files[0].size) <= 1024000) {

      this.oirsrespuesta.controls['size'].setErrors(null)
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imgbase64 = this.sanitizer.bypassSecurityTrustHtml(`${reader.result}`)

        this.oirsrespuesta.controls['base64'].setValue(this.imgbase64.changingThisBreaksApplicationSecurity)
        this.oirsrespuesta.controls['TPFormato'].setValue(this.tipoformatoimagen[1])
        if ($event.target.files[0].type == 'application/pdf') {
          this.image = this.sanitizer.bypassSecurityTrustHtml(`<object class="container-fluid" style="min-height:
        800px;max-height:auto;"
         data="${reader.result}" type = "application/pdf" > </object>`)
        } else {
          this.image = this.sanitizer.bypassSecurityTrustHtml(`<img class="img-thumbnail"
         src="${reader.result}" > </img>`)
        }

      };
      if ($event.target.files[0] !== undefined) {

        // this.oirsinput.controls['size'].setValue($$event.target.files[0].size)

        if ($event.target.files[0].size < 1000) {
          this.size = $event.target.files[0].size;
          this.unit = "bytes";
        } else if ($event.target.files[0].size < 1000 * 1000) {
          this.size = $event.target.files[0].size / 1000;
          this.unit = "kb";
        } else if ($event.target.files[0].size < 1000 * 1000 * 1000) {
          this.size = $event.target.files[0].size / 1000 / 1000;
          this.unit = "mb";
        } else {
          this.size = $event.target.files[0].size / 1000 / 1000 / 1000;
          this.unit = "gb";
        }
      } else {

        this.oirsrespuesta.controls['size'].setErrors({ 'Incorrect': true })
        this.oirsrespuesta.controls['base64'].setValue(null)
        this.oirsrespuesta.controls['size'].setValue(null)
      }


    } else {
      //this.eliminar();
      this.oirsrespuesta.controls['size'].setErrors({ 'Incorrect': true })
    }
  }

  onSubmit() {
    //console.log(this.datos)
    this.confirmdialogservice.confirm('Confirmar', '¿Está Seguro que Desea Guardar y Enviar su Requerimiento?', true)

      .then((confirmed) => {

        if (confirmed) {

          if (this.datos[0].CDTPEstado != 0) {
            this._service.IoirsRespuestaAsignado(this.id, this.auth.datosusuario.data.rut, this.oirsrespuesta.value, this.datosDetalle.solicitud).subscribe(
              (resp) => {

                // this.cambioTpDocumento(1)
                if (resp != undefined) {
                  this.confirmdialogservice.confirm('Error en Ingreso de Solicitud',
                    'Ocurrió un Error al Momento de Ingresar su Solicitud, Sí El Problema Persiste por Favor Contacte con mesadeayuda@directemar.cl', false).then((confirmed) => {
                      if (confirmed) {

                        //this.reset()
                      }
                    }).catch(() => this.router.navigate(['/inicio']));
                } else {
                  this.confirmdialogservice.confirm('Respuesta de Solicitud',
                    'Solicitud Respondida Correctamente', false).then((confirmed) => {
                      if (confirmed) {

                        this.router.navigate(['/inicio']);
                      }
                    }).catch(() => this.router.navigate(['/inicio']));
                }



              })
          } else {
            this._service.IoirsRespuestaDirecta(this.id, this.auth.datosusuario.data.rut, this.oirsrespuesta.value, this.datosDetalle.solicitud).subscribe(
              (resp) => {

                // this.cambioTpDocumento(1)
                if (resp != undefined) {
                  this.confirmdialogservice.confirm('Error en Ingreso de Solicitud',
                    'Ocurrió un Error al Momento de Ingresar su Solicitud, Sí El Problema Persiste por Favor Contacte con mesadeayuda@directemar.cl', false).then((confirmed) => {
                      if (confirmed) {

                        //this.reset()
                      }
                    }).catch(() => this.router.navigate(['/inicio']));
                } else {
                  this.confirmdialogservice.confirm('Respuesta de Solicitud',
                    'Solicitud Respondida Correctamente', false).then((confirmed) => {
                      if (confirmed) {

                        this.router.navigate(['/inicio']);
                      }
                    }).catch(() => this.router.navigate(['/inicio']));
                }



              })
          }

          //  this.confirmdialogservice.confirm('Respuesta',
          //  'Respuesta Almacenada Correctamente',false).then((confirmed) => {
          //   if (confirmed) {

          //    this.router.navigate(['/inicio']);
          //     }
          //   }).catch(() => this.router.navigate(['/inicio']));


          //this.router.navigate(['/inicio']);
        }
      }
      )
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));






  }
}
